import { render } from "./AdminLanguagesWithData.component.vue?vue&type=template&id=127a82a0"
import script from "./AdminLanguagesWithData.component.vue?vue&type=script&lang=js"
export * from "./AdminLanguagesWithData.component.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__